export const WHATSAPP_NUMBER = "+1 581 222 2117";
export const WHATSAPP_LINK = "https://wa.me/15812222117";
export const CONTACT_EMAIL = "contact@kora-nex.com";

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/creation-site-web", label: "Création de sites web" },
  { to: "/applications-mobiles", label: "Applications mobiles" },
  { to: "/referencement-seo", label: "Référencement SEO" },
  { to: "/maintenance-site-web", label: "Maintenance" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const SERVICE_OPTION_BY_SLUG = {
  "creation-site-web": "Création de site web",
  "applications-mobiles": "Application mobile",
  "referencement-seo": "Référencement SEO",
  "maintenance-site-web": "Maintenance",
};

export const SERVICE_OPTIONS = [
  "Création de site web",
  "Application mobile",
  "Référencement SEO",
  "Maintenance",
  "Plusieurs services",
  "Autre demande",
];

export const BUDGET_OPTIONS = [
  "Je ne sais pas encore",
  "Moins de 500 000 FCFA",
  "Plus de 500 000 FCFA",
];

export const TIMELINE_OPTIONS = [
  "7 jours",
  "10 jours",
  "14 jours",
  "Flexible",
];

export const PORTFOLIO_CATEGORIES = [
  { value: "all", label: "Tout" },
  { value: "site-web", label: "Sites web" },
  { value: "e-commerce", label: "E-commerce" },
  { value: "application-mobile", label: "Applications mobiles" },
  { value: "refonte", label: "Refonte & optimisation" },
];

export const SERVICES = [
  {
    slug: "creation-site-web",
    navLabel: "Création de sites web",
    kicker: "01 / CRÉATION WEB",
    title: "Création de sites web",
    short:
      "Sites vitrines, sites d'entreprise, pages de vente et boutiques en ligne. Des sites modernes, rapides, adaptés aux mobiles et conçus pour convertir les visiteurs en clients.",
    cta: "Créer mon site web",
    heroTitle: "Des sites web conçus pour convertir",
    heroText:
      "Site vitrine, site professionnel, landing page ou boutique e-commerce : Koranex conçoit des sites modernes, rapides et adaptés aux mobiles, pensés pour transformer vos visiteurs en clients.",
    offerings: [
      {
        title: "Sites vitrines",
        text: "Une présence en ligne claire et professionnelle pour présenter votre activité, vos services et capter des demandes de contact.",
      },
      {
        title: "Sites d'entreprise",
        text: "Un site complet et structuré qui renforce votre crédibilité : présentation, équipe, réalisations, contenus de fond.",
      },
      {
        title: "Landing pages",
        text: "Des pages de vente ciblées, construites autour d'un objectif précis : conversion, inscription ou prise de rendez-vous.",
      },
      {
        title: "Boutiques en ligne",
        text: "Catalogue, panier, paiement et gestion des commandes : une e-boutique fluide pour vendre vos produits en ligne.",
      },
      {
        title: "Refonte de site existant",
        text: "Audit de votre site actuel, modernisation du design, amélioration des performances et du référencement.",
      },
    ],
    steps: [
      { title: "Échange et analyse", text: "Nous partons de vos objectifs, de votre activité et de vos clients pour cadrer le projet." },
      { title: "Proposition et conception", text: "Architecture du site, maquettes sur mesure et validation avec vous avant tout développement." },
      { title: "Développement et validation", text: "Réalisation du site, tests sur ordinateur, tablette et mobile, ajustements avec vos retours." },
      { title: "Mise en ligne et accompagnement", text: "Publication du site, puis maintenance et référencement SEO selon vos besoins." },
    ],
    deliverables: [
      "Un site responsive, adapté aux ordinateurs, tablettes et smartphones",
      "Des contenus structurés et optimisés pour le référencement naturel",
      "Un formulaire de contact fonctionnel relié à vos outils",
      "Une prise en main expliquée pour modifier vos contenus",
      "Des options de maintenance et de SEO après la mise en ligne",
    ],
    seo: {
      title: "Création de sites web — Koranex",
      description:
        "Sites vitrines, sites d'entreprise, landing pages et boutiques en ligne : Koranex conçoit des sites modernes, rapides et pensés pour convertir. Devis gratuit.",
    },
  },
  {
    slug: "applications-mobiles",
    navLabel: "Applications mobiles",
    kicker: "02 / MOBILE ENGINE",
    title: "Applications mobiles",
    short:
      "Conception et développement d'applications mobiles Android et iOS adaptées aux besoins des entreprises et des entrepreneurs.",
    cta: "Créer mon application",
    heroTitle: "Votre application mobile, de l'idée au produit",
    heroText:
      "Koranex conçoit et développe des applications Android et iOS adaptées à vos besoins : commerce, réservation, services ou gestion. Une expérience simple pour vos utilisateurs, un outil puissant pour votre activité.",
    offerings: [
      {
        title: "Application de réservation",
        text: "Calendrier interactif, choix des créneaux, confirmations et rappels automatiques pour vos clients.",
      },
      {
        title: "Application de commerce en ligne",
        text: "Catalogue produits, panier, paiement, suivi des commandes et espace client fidélité.",
      },
      {
        title: "Application de services professionnels",
        text: "Prise de rendez-vous, demandes de devis, messagerie et suivi des interventions pour vos clients.",
      },
      {
        title: "Application de gestion et productivité",
        text: "Tableaux de bord, suivi d'activité, gestion d'équipe et outils internes sur mesure.",
      },
    ],
    steps: [
      { title: "Analyse du besoin", text: "Compréhension de vos utilisateurs, des fonctionnalités clés et des contraintes techniques." },
      { title: "Conception UX/UI", text: "Parcours utilisateurs et maquettes d'écrans validés avec vous avant développement." },
      { title: "Développement", text: "Réalisation de l'application pour Android et iOS selon les besoins du projet." },
      { title: "Tests", text: "Vérifications sur différents appareils et tailles d'écran, corrections et ajustements." },
      { title: "Préparation à la publication", text: "Accompagnement pour la mise à disposition sur les boutiques d'applications, sous réserve de la validation de vos comptes développeur et des exigences des plateformes." },
      { title: "Maintenance", text: "Mises à jour, correctifs et évolutions après le lancement, si vous le souhaitez." },
    ],
    deliverables: [
      "Une application conçue pour Android et iOS selon vos besoins",
      "Des écrans soignés : accueil, navigation, listes, détails et profil utilisateur",
      "Une expérience simple et rapide pour vos utilisateurs",
      "Un accompagnement à la préparation de la publication",
      "Des options de maintenance et d'évolution après lancement",
    ],
    seo: {
      title: "Applications mobiles Android & iOS — Koranex",
      description:
        "Koranex conçoit et développe des applications mobiles Android et iOS : réservation, commerce, services, gestion. Devis gratuit pour votre application.",
    },
  },
  {
    slug: "referencement-seo",
    navLabel: "Référencement SEO",
    kicker: "03 / VISIBILITÉ GOOGLE",
    title: "Référencement naturel SEO",
    short:
      "Optimisation technique, recherche de mots-clés, amélioration des pages et stratégie de contenu pour améliorer votre visibilité dans les résultats de recherche.",
    cta: "Améliorer ma visibilité",
    heroTitle: "Soyez visible là où vos clients vous cherchent",
    heroText:
      "Audit, mots-clés, optimisation technique et contenu : Koranex construit une stratégie de référencement naturel durable pour améliorer la visibilité de votre entreprise sur les moteurs de recherche.",
    offerings: [
      { title: "Audit SEO", text: "Analyse complète de votre site : technique, contenu, structure et opportunités d'amélioration." },
      { title: "Recherche de mots-clés", text: "Identification des requêtes réellement tapées par vos clients potentiels dans votre secteur." },
      { title: "Optimisation technique", text: "Vitesse, balises, structure, données structurées, compatibilité mobile et indexation." },
      { title: "Optimisation des pages", text: "Titres, descriptions, hiérarchie des contenus et maillage interne page par page." },
      { title: "Stratégie de contenu", text: "Sujets, calendrier et rédaction de contenus utiles qui répondent aux questions de vos clients." },
      { title: "Amélioration des performances", text: "Un site rapide et accessible, deux critères essentiels pour le référencement et vos visiteurs." },
      { title: "Suivi de l'évolution", text: "Tableaux de bord et rapports réguliers pour suivre les positions, le trafic et les actions menées." },
    ],
    steps: [
      { title: "Audit initial", text: "État des lieux de votre visibilité actuelle et de vos concurrents." },
      { title: "Plan d'action", text: "Priorisation des optimisations à fort impact, adaptées à votre secteur." },
      { title: "Mise en œuvre", text: "Optimisations techniques et éditoriales, mois après mois." },
      { title: "Suivi et ajustements", text: "Rapports clairs et ajustement de la stratégie selon les résultats." },
    ],
    deliverables: [
      "Un audit clair et des recommandations concrètes",
      "Une stratégie de mots-clés adaptée à votre marché",
      "Des optimisations techniques et éditoriales appliquées",
      "Des rapports de suivi compréhensibles",
    ],
    note: "Le référencement naturel demande du temps : les résultats se construisent sur plusieurs mois. Aucune position précise sur Google ne peut être garantie — méfiez-vous de quiconque vous la promet.",
    seo: {
      title: "Référencement naturel SEO — Koranex",
      description:
        "Audit SEO, mots-clés, optimisation technique et stratégie de contenu : Koranex améliore durablement votre visibilité sur Google. Devis gratuit.",
    },
  },
  {
    slug: "maintenance-site-web",
    navLabel: "Maintenance",
    kicker: "04 / SÉRÉNITÉ TOTALE",
    title: "Maintenance de sites web",
    short:
      "Mises à jour, sauvegardes, sécurité, corrections de bugs, surveillance et optimisation des performances pour garder votre site fiable et opérationnel.",
    cta: "Sécuriser mon site",
    heroTitle: "Un site fiable, sécurisé et toujours opérationnel",
    heroText:
      "Koranex prend en charge la maintenance de votre site web : mises à jour, sauvegardes, sécurité, corrections et surveillance. Vous vous concentrez sur votre activité, nous veillons sur votre site.",
    offerings: [
      { title: "Mises à jour", text: "Système, extensions et dépendances maintenus à jour pour éviter failles et incompatibilités." },
      { title: "Sauvegardes", text: "Sauvegardes régulières de vos fichiers et de vos données, restaurables en cas de problème." },
      { title: "Sécurité", text: "Surveillance des vulnérabilités, durcissement de la configuration et protection contre les attaques courantes." },
      { title: "Corrections de bugs", text: "Diagnostic et correction des dysfonctionnements signalés ou détectés." },
      { title: "Surveillance du fonctionnement", text: "Veille sur la disponibilité du site et alertes en cas d'interruption." },
      { title: "Optimisation des performances", text: "Temps de chargement, poids des pages et fluidité, contrôlés et améliorés régulièrement." },
      { title: "Modifications de contenu", text: "Ajouts et ajustements de textes, images et pages selon vos besoins." },
    ],
    steps: [
      { title: "Diagnostic initial", text: "Revue de votre site existant : état technique, sécurité, performances." },
      { title: "Choix de la formule", text: "Une formule adaptée à la criticité de votre site et à votre rythme d'évolution." },
      { title: "Maintenance continue", text: "Interventions régulières, sauvegardes et surveillance." },
      { title: "Compte rendu", text: "Un point clair sur les actions réalisées et l'état de votre site." },
    ],
    deliverables: [
      "Formule Essentielle — l'indispensable : mises à jour, sauvegardes et surveillance",
      "Formule Sérénité — maintenance complète avec corrections et petites évolutions",
      "Formule Sur mesure — un accompagnement construit autour de vos besoins précis",
      "Tarifs définis ensemble, sur devis, selon votre site et vos besoins",
    ],
    note: "Votre site n'a pas été créé par Koranex ? Aucun problème : nous pouvons prendre en charge la maintenance d'un site existant après un diagnostic initial.",
    seo: {
      title: "Maintenance de sites web — Koranex",
      description:
        "Mises à jour, sauvegardes, sécurité, corrections et surveillance : Koranex maintient votre site web fiable et opérationnel. Devis gratuit.",
    },
  },
];

export const WHY_ITEMS = [
  { icon: "Target", title: "Des solutions adaptées", text: "Chaque projet est conçu autour de vos besoins, jamais l'inverse." },
  { icon: "Palette", title: "Design professionnel", text: "Une expérience utilisateur soignée, moderne et sur mesure." },
  { icon: "Smartphone", title: "Pensé pour le mobile", text: "Des sites parfaitement adaptés aux smartphones et tablettes." },
  { icon: "AppWindow", title: "Des applications simples", text: "Des applications mobiles pensées pour être simples à utiliser." },
  { icon: "Search", title: "SEO dès la conception", text: "Le référencement est intégré dès les premières maquettes." },
  { icon: "LifeBuoy", title: "Accompagnement durable", text: "Un suivi et une maintenance possibles bien après la livraison." },
  { icon: "MessagesSquare", title: "Communication claire", text: "Des réponses rapides et un suivi de projet transparent." },
];

export const PROCESS_STEPS = [
  { title: "Échange et analyse", text: "Nous prenons le temps de comprendre votre besoin, vos objectifs et vos clients." },
  { title: "Proposition et conception", text: "Nous définissons ensemble la solution et créons les maquettes de votre projet." },
  { title: "Développement et validation", text: "Nous réalisons le projet et recueillons vos retours à chaque étape clé." },
  { title: "Mise en ligne et accompagnement", text: "Nous livrons votre projet et restons à vos côtés : maintenance, SEO, évolutions." },
];

export const FAQ_ITEMS = [
  {
    q: "Combien coûte la création d'un site web ?",
    a: "Le coût dépend du périmètre de votre projet : nombre de pages, fonctionnalités, boutique en ligne ou non, contenus à produire. Chaque projet fait l'objet d'un devis gratuit et personnalisé, sans engagement.",
  },
  {
    q: "Combien de temps faut-il pour créer un site ?",
    a: "Le calendrier dépend de la complexité du projet et de la rapidité des échanges. Un délai précis est défini ensemble dans la proposition, après l'analyse de votre besoin.",
  },
  {
    q: "Pouvez-vous développer une application Android et iOS ?",
    a: "Oui. Selon les besoins de votre projet, nous développons des applications compatibles Android et iOS. La publication sur les boutiques d'applications reste soumise à la validation de vos comptes développeur et aux exigences des plateformes.",
  },
  {
    q: "Comment fonctionne le référencement SEO ?",
    a: "Nous partons d'un audit de votre site, identifions les mots-clés pertinents, puis optimisons la technique et les contenus. Le référencement naturel demande du temps : les résultats se construisent sur plusieurs mois et aucune position précise sur Google ne peut être garantie.",
  },
  {
    q: "Proposez-vous la maintenance après la livraison ?",
    a: "Oui. Nous proposons plusieurs formules de maintenance : mises à jour, sauvegardes, sécurité, corrections et petites évolutions. Nous pouvons également maintenir un site existant qui n'a pas été créé par nous.",
  },
  {
    q: "Puis-je vous confier la refonte de mon site existant ?",
    a: "Bien sûr. Nous commençons par un audit de votre site actuel, puis nous vous proposons une refonte : design modernisé, meilleures performances et optimisation pour le référencement.",
  },
  {
    q: "Comment obtenir un devis ?",
    a: "Remplissez le formulaire de contact en décrivant votre projet, ou contactez-nous directement sur WhatsApp. Le devis est gratuit et sans engagement.",
  },
];

export const TICKER_ITEMS = [
  "Site Web Professionnel",
  "Application iOS & Android",
  "Référencement SEO",
  "Maintenance & Sécurité",
  "Accompagnement de A à Z",
];
